<template>
    <div class="loadLayout">
        <div class="topLoad">
            <div class="topLoad1">
                <div class="search-left-bot">
                    <span @click="handleTabDate(10)" :class="[search_btn_type === 10 ? 'btn-bot-s' : 'btn-bot']">年</span>
                    <span @click="handleTabDate(20)" :class="[search_btn_type === 20 ? 'btn-bot-s' : 'btn-bot']">月</span>
                    <span @click="handleTabDate(30)" :class="[search_btn_type === 30 ? 'btn-bot-s' : 'btn-bot']">日</span>
                </div>
                <span style="margin-left: 50px;">时间：</span>
                <div class="search-right-bot">
                    <el-date-picker append-to-body @change="handleDateChange" v-model="search_date" style="width:150px;padding:0 5px;" size="mini" :type="pickType" :placeholder="pickTp" :format="pickFormat" :value-format="pickFormat"></el-date-picker>
                </div>
                <div class="leader-style-form" style="height: 1.2rem;padding: 0;margin: 0;">
                    <el-button size="small"  @click="getTransformerExcel" style="height: 1.2rem;">导出</el-button>
                </div>
            </div>
            <div class="topLoad2">
                <div class="topLoad3">
                    <v-chart :auto-resize="true" :options="line" ref="line" style="width: 100%;height: 19.5rem;"/>                
                </div>
                <div class="topLoad4">
                    <span style="margin-bottom: 10px;padding: 0;margin-top: 0;">当{{ search_btn_text}}负载率排行</span>
                    <div style="width: 100%;overflow: hidden;min-width:0;">
                        <el-table ref="tableRef" :data="tableData" height="18rem" class="leader-style-table" style="table-layout: fixed;">
                            <el-table-column label="排位" width="100" type="index" show-overflow-tooltip></el-table-column>
                            <el-table-column label="变压器" min-width="200px" prop="transformer_name" show-overflow-tooltip></el-table-column>
                            <el-table-column label="负载率" min-width="200px" prop="load_rate" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.load_rate }}%
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="bottomLoad">
            <el-scrollbar style="height: 20rem; width: 100%;opacity: 1;">
                <div class="bottomLoad-s">
                    <div class="bottomLoad-s-item" v-for="item in tableData" :key="item.transformer_id" @click="goDetail(item)">
                        <img src="../../../assets/image/custom/bot-top-2.png" alt="" />
                        <div style="display: flex;flex-direction: column;padding: 10px;">
                            <span class="top-part1-c" style="margin: 10px;"><span style="color: #56FCFE;">名称：</span>{{ item.transformer_name }}</span>
                            <span style="margin: 10px;"><span style="color: #56FCFE;">当{{ search_btn_text}}最高负载率：</span>{{ item.load_rate }}%</span>
                        </div>
                        
                    </div> 
                </div>
            </el-scrollbar>
            
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import utils from "@/utils/utils";
import "echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
// 原来你只写了
import 'echarts/lib/component/legend'
// ✅ 必须再加这一行！滚动图例单独组件
import 'echarts/lib/component/legendScroll'
import * as api from "@/http/api";
import { getTransformerExcel } from "@/http/api";
export default {
    data() {
        return {
            search_btn_type: 10,
            search_btn_text: '年',
            search_date: dayjs().format('YYYY'),
            pickType: 'year',
            pickTp: '选择年份',            
            pickFormat: 'yyyy',
            x_list: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            series: [
                {name: '1号变压器', type: 'line', data: [80, 90, 75, 85, 95, 88, 92],smooth: true,symbol: "none"},
                {name: '2号变压器', type: 'line', data: [90, 80, 85, 95, 85, 92, 88],smooth: true,symbol: "none"},
                {name: '3号变压器', type: 'line', data: [75, 85, 95, 85, 92, 88, 92],smooth: true,symbol: "none"},
                {name: '4号变压器', type: 'line', data: [85, 95, 85, 92, 88, 92, 85],smooth: true,symbol: "none"},
                {name: '5号变压器', type: 'line', data: [95, 85, 92, 88, 92, 85, 90],smooth: true,symbol: "none"},
                {name: '6号变压器', type: 'line', data: [88, 92, 85, 90, 85, 92, 88],smooth: true,symbol: "none"},
                {name: '7号变压器', type: 'line', data: [92, 85, 90, 85, 92, 88, 92],smooth: true,symbol: "none"},
                {name: '8号变压器', type: 'line', data: [85, 90, 85, 92, 88, 92, 85],smooth: true,symbol: "none"},
                {name: '9号变压器', type: 'line', data: [90, 85, 92, 88, 92, 85, 90],smooth: true,symbol: "none"},
                {name: '10号变压器', type: 'line', data: [85, 92, 88, 92, 85, 90, 85],smooth: true,symbol: "none"},
            ],
            legend: ['1号变压器', '2号变压器', '3号变压器', '4号变压器', '5号变压器', '6号变压器', '7号变压器', '8号变压器', '9号变压器', '10号变压器'],
            tableData: []

        }
    },
    methods: {
        handleTabDate(tab) {
            this.search_btn_type = tab;
            console.log(this.search_date)
            if(tab === 10) {
                this.pickType = 'year';
                this.pickFormat ='yyyy';
                this.pickTp = '请选择年份';
                this.search_date = dayjs().format('YYYY');
                this.search_btn_text = '年';
            } else if (tab === 20) {
                this.pickType = 'month';
                this.pickFormat ='yyyy-MM';
                this.pickTp = '请选择月份';
                this.search_date = dayjs().format('YYYY-MM');
                this.search_btn_text = '月';
            } else {
                this.pickType = 'date';
                this.pickFormat ='yyyy-MM-dd';
                this.pickTp = '请选择日期';
                this.search_btn_text = '日';
                this.search_date = dayjs().format('YYYY-MM-DD'); 
            }
            this.getMaxTransformerLoad();
        },
        handleDateChange(date) {
            this.search_date = date;
            this.getMaxTransformerLoad()

        },
        getMaxTransformerLoad() {
            api.getMaxTransformer({show_day: this.search_date, search_type: this.search_btn_type}).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.x_list;
                    // 数据
                    this.series = [];
                    // 图例
                    this.legend = [];

                    res.bus_json.y_list.forEach(item => {
                        let everyData = {
                            name: item.transformer_name,
                            type: "line",
                            data: item.dataList,
                            itemStyle: {
                                color: item.column_color
                            },
                            smooth: true,
                            symbol: "none"
                        };
                        this.legend.push(item.transformer_name);
                        this.series.push(everyData);
                    })
                    this.tableData = res.bus_json.maxList;
                }
            })
        },
        goDetail(item) {
            
            sessionStorage.setItem("activeTab", JSON.stringify({ name:'MaxLoadDetail', query:{ point_id: item.point_id, search_date: this.search_date, search_type: this.search_btn_type }}));
            this.$router.push({ name:'MaxLoadDetail', query:{ point_id: item.point_id, search_date: this.search_date, search_type: this.search_btn_type+'' } })
        },
        getTransformerExcel() {
            api.getTransformerExcel({show_day: this.search_date, search_type: this.search_btn_type}).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName = "变压器负载率" + ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
            })
        }
    },
    mounted() {
        const queryData = this.$route.query;
        this.search_date = queryData.search_date;
        this.search_type = queryData.search_type;
        if(!this.search_type) {
            this.search_type = '10';
            this.search_btn_type = 10;
            this.search_btn_text = '年';
            this.pickType = 'year';
            this.pickFormat ='yyyy';
            this.pickTp = '请选择年份';
            this.search_date = dayjs().format('YYYY');
        }
        if('10' === this.search_type) {
            this.search_btn_type = 10;
            this.search_btn_text = '年';
            this.pickType = 'year';
            this.pickFormat ='yyyy';
            this.pickTp = '请选择年份';
        } else if('20' === this.search_type) {
            this.search_btn_type = 20;
            this.search_btn_text = '月';
            this.pickType = 'month';
            this.pickFormat ='yyyy-MM';
            this.pickTp = '请选择月份';
        } else {
            this.search_btn_text = '日';
            this.search_btn_type = 30;
            this.pickType = 'date';
            this.pickFormat ='yyyy-MM-dd';
            this.pickTp = '请选择日期';
            this.search_btn_text = '日';
        }
        this.getMaxTransformerLoad()
        this.$nextTick(() => {
            this.$refs.tableRef.doLayout()
        })
        
    },
    computed: {
        line() {
            const options = {
                // title: {
                //     text: "瞬时量趋势分析"
                // },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.legend,
                    type: 'scroll',
                    textStyle: {
                        color: "#fff"
                    },
                    left: 25,
                    pageIconColor: '#fee098',
                    pageIconInactiveColor: '#348f9b',
                    // 分页页码文字样式
                    pageTextStyle: {
                        color: '#fff'
                    },
                },
                calculable: true,
                xAxis: {
                    data: this.x_list,
                    axisLabel: {
                        // interval: 0, //横轴信息全部显示
                        //   rotate: -40, //-30度角倾斜显示
                        //y轴文字的配置
                        textStyle: {
                            color: "#fff" //颜色
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: `单位：%`,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor() //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "13%",
                    containLabel: true
                },
                series: this.series,
               // color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"]
            };
            return options;
        }
    },
}
</script>

<style scoped lang="scss">
.loadLayout {
    display: flex;
    flex-direction: column;
    height: 100%;
    color: #fff;
    .topLoad {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-left: 10px;
        padding-right: 10px;
        .topLoad1 {
            flex: 1;
            display: flex;
            align-items: center;
            .search-left-bot {
                display: flex;
                margin-left: 20px;
                .btn-bot {
                    width: 2.5rem;
                    height: 1.2rem;
                    box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid;
                    border-image: linear-gradient(354deg, rgba(27, 99, 100, 1), rgba(86, 252, 254, 1), rgba(34, 118, 119, 1)) 1 1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 10px;
                }
                .btn-bot-s {
                    width: 2.5rem;
                    height: 1.2rem;
                    background: rgba(86,252,254,0.7);
                    box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #56FCFE;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 10px;
                }
            }
            .search-right-bot {
                min-height: 0;
                overflow: hidden;
                ::v-deep .el-date-editor {
                    .el-input__inner {
                        color: #fff;
                        background-color: transparent;
                        border: 1px solid #56fcff;
                        font-size: 0.6rem;
                    }
                }
            }
        }
        .topLoad2 {
            flex: 7;
            display: flex;
            .topLoad3 {
                flex: 3;
                overflow: hidden;
                margin-top: 10px;
            }
            .topLoad4 {
                padding: 0;
                //border: 1px solid red;
                flex: 2;
                display: flex;
                flex-direction: column;
                align-items: center;
                overflow: hidden;
               
            }
        }
    }
    .bottomLoad {
        flex: 1;
        color: #fff;
        //border: 1px solid red;
        padding: 10px;
        &-s {
            padding-left: 20px;
            display: grid;
            grid-template-columns: repeat(4,1fr);
            gap: 1rem;
            &-item {
                background: rgba(86,252,254,0.3);
                width: 400px;
                height: 80px;
                display: flex;
                align-items: center;
                padding: 20px;
                cursor: pointer;
                img {
                    width: 90px;
                    height: 90px;
                }
            }
        }

        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden; /* 禁止横向滚动 */
        }

        /* 隐藏横向滚动条 */
        ::v-deep .el-scrollbar__bar.is-horizontal {
            display: none !important;
        }
        
        ::v-deep .el-scrollbar__bar {
            //opacity: 1 !important;
            background: #194f6d; /* 轨道底色 */
            border-radius: 10px;
            width: 8px;
        }

        ::v-deep .el-scrollbar__thumb {
            background: #348f9b;
            border-radius: 10px;
            &:hover {
                background: #348f9b;
            }
        }
        
    }
}
</style>